import { render, staticRenderFns } from "./GenericPodAssigner.vue?vue&type=template&id=604f454f&scoped=true"
import script from "./GenericPodAssigner.vue?vue&type=script&lang=ts&setup=true"
export * from "./GenericPodAssigner.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GenericPodAssigner.vue?vue&type=style&index=0&id=604f454f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604f454f",
  null
  
)

export default component.exports